import React, { useRef } from 'react';

import useTranslate from '../../../../common/hooks/useTranslate';
import useClickOutside from '../../../../common/hooks/useClickOutside';

import IdentityManager from '../../../../common/services/identity/IdentityManagerFactory';

import { INavigation } from '../../types/INavigation';

import { Link } from 'react-router-dom';
import Icon from '../../icon/icon';

import './userNavigation.scss';

const UserNavigation: React.FC<INavigation> = ({ setNav, id }) => {
  const { t } = useTranslate();
  const wrapperRef = useRef(null);

  const identity = IdentityManager.getManager();

  const clickOutsideHandler = () => {
    setNav(false);
  };

  useClickOutside(wrapperRef, clickOutsideHandler, id);

  const handleLogout = () => {
    sessionStorage.clear();
    identity.signOut();
  }

  return (
    <div className='navigation-container' ref={wrapperRef}>
      <Link to='/profile'>
        <div className='navigation-btn pointer' onClick={() => setNav(false)}>
          <span>{t('NAVIGATION.PROFILE')}</span>
          <Icon name='far fa-user' />
        </div>
      </Link>
      <div className='navigation-btn pointer' onClick={handleLogout}>
        <span>{t('NAVIGATION.LOGOUT')}</span>
        <Icon name='far fa-door-open' />
      </div>
    </div>
  );
};

export default UserNavigation;
